import styled from 'styled-components'

export const Container = styled.div`
  padding-top: ${({ logged }) => (logged ? '112px' : '72px')};
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-width: 100%;
`

export const SectionPart = styled.section`
  background-image: url('/img/part.jpg');
  height: 440px;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  padding-bottom: 103px;

  h2 {
    color: #ffffff;
    font-weight: 600;
    font-size: 32px;
    line-height: 48px;
    padding-top: 103px;

    max-width: 685px;
  }

  h4 {
    color: #ffffff;
    font-weight: 600;
    font-size: 18px;
    line-height: 26px;
    padding-top: 32px;
    margin: 0 24px;
  }

  div {
    padding-top: 48px;
    display: flex;
    width: 100%;
    max-width: 550px;
    justify-content: center;

    button {
      margin-left: 15px !important ;
      margin-right: 15px !important ;
      height: 32px;
    }
  }

  @media (max-width: 720px) {
    padding-bottom: 57px;
    height: auto;
    h2 {
      margin: 0 20px;
      max-width: 328px;
      text-align: center;
      padding-top: 57px;
    }
    h4 {
      max-width: 328px;
      text-align: center;
      margin: 0 10px;
    }

    button {
      max-width: 140px !important ;
      font-weight: 600;
      font-size: 12px;
      line-height: 24px;
      margin-left: 6px !important ;
      margin-right: 6px !important ;
    }
  }
`

export const SectionItens = styled.section`
  display: flex;
  justify-content: center;
  height: inherit;
`

export const ListItens = styled.ul`
  display: flex;
  justify-content: center;

  li {
    display: flex;
    flex-direction: column;
    max-width: 385px;
    align-items: center;
    text-align: center;
    padding-top: 68px;
    margin: 0 12px;
    margin-bottom: 48px;

    a {
      color: var(--blue);
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      text-decoration: none;
    }
    &:hover {
      a {
        text-decoration: underline;
      }
    }

    p {
      color: var(--gray);
      font-size: 16px;
      line-height: 24px;
      font-weight: normal;
    }
  }

  @media (max-width: 1150px) {
    flex-direction: column;
    align-items: center;
    margin-top: 50px;

    li {
      margin-bottom: 36px;
      padding-top: 0px;
    }
  }
`

export const Footer = styled.footer`
  width: 100%;
  height: 142px;
  background: var(--blue);
  text-align: center;
  flex-shrink: 0;

  div {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  h4 {
    color: #ffffff;
    font-weight: normal;
    font-size: 10px;
    line-height: 14px;
    margin-top: 32px;
    margin-bottom: 18px;
  }

  @media (max-width: 1150px) {
    h4 {
      margin-top: 0px;
      margin-bottom: 0px;
      padding: 32px 0px 16px 0px;
      margin: 0 15px;
    }
  }
`
